export function employeeHasRoleInDepartments(
  employee,
  selectedDepartments,
  roleNames
) {
  const selected = new Set(selectedDepartments || []);
  if (selected.size === 0) return false;

  const departmentByRoleId = new Map(
    (roleNames || []).map((role) => [role.id, role.role_type])
  );
  const availableRoles = Array.isArray(employee?.available_role_info)
    ? employee.available_role_info
    : [];

  return (
    availableRoles.some((assignment) =>
      selected.has(departmentByRoleId.get(assignment.scheduled_role))
    ) || selected.has(employee?.role_type)
  );
}

export function getEmployeeRolesInDepartments(
  employee,
  selectedDepartments,
  roleNames,
  filterActive
) {
  const availableRoles = Array.isArray(employee?.available_role_info)
    ? employee.available_role_info
    : [];
  if (!filterActive) return availableRoles;

  const selected = new Set(selectedDepartments || []);
  const departmentByRoleId = new Map(
    (roleNames || []).map((role) => [role.id, role.role_type])
  );

  return availableRoles.filter((assignment) =>
    selected.has(departmentByRoleId.get(assignment.scheduled_role))
  );
}

export function getDefaultScheduleRole(employee, scheduleRoles) {
  const availableRoles = Array.isArray(scheduleRoles) ? scheduleRoles : [];
  const mainRole = availableRoles.find(
    (assignment) => assignment.scheduled_role === employee?.main_role_id
  );

  return mainRole || (availableRoles.length === 1 ? availableRoles[0] : null);
}

export function getOutOfFilterShifts(employee, visibleShifts, allShifts) {
  const employeeId = typeof employee === "object" ? employee?.id : employee;
  const userId = typeof employee === "object" ? employee?.user?.id : null;
  const visible = Array.isArray(visibleShifts) ? visibleShifts : [];
  const visibleIds = new Set(
    visible.map((shift) => shift?.id).filter((id) => id !== undefined && id !== null)
  );

  return (Array.isArray(allShifts) ? allShifts : []).filter((shift) => {
    const belongsToEmployee =
      shift?.store_team_member === employeeId ||
      (userId != null && shift?.user_id === userId);
    if (!belongsToEmployee) {
      return false;
    }

    return shift.id !== undefined && shift.id !== null
      ? !visibleIds.has(shift.id)
      : !visible.includes(shift);
  });
}

export function getRoleNamesInDepartments(
  selectedDepartments,
  roleNames,
  filterActive
) {
  const roles = Array.isArray(roleNames) ? roleNames : [];
  if (!filterActive) return roles;

  const selected = new Set(selectedDepartments || []);
  return roles.filter((role) => selected.has(role.role_type));
}

export function getScheduleRoleIds(employee, roleNames) {
  if (Array.isArray(employee?.schedule_available_role_info)) {
    return employee.schedule_available_role_info.map(
      (assignment) => assignment.scheduled_role
    );
  }

  return (Array.isArray(roleNames) ? roleNames : []).map((role) => role.id);
}

export function getScheduleRoleIdForPaste(employee, copiedRoleId) {
  if (Array.isArray(employee?.schedule_available_role_info)) {
    if (employee.schedule_default_role_id != null) {
      return employee.schedule_default_role_id;
    }

    return employee.schedule_available_role_info.some(
      (assignment) => assignment.scheduled_role === copiedRoleId
    )
      ? copiedRoleId
      : null;
  }

  return employee?.primary_role_id || copiedRoleId || null;
}
